import { render, staticRenderFns } from "./hover-effect.vue?vue&type=template&id=5c7e2541&"
import script from "./hover-effect.vue?vue&type=script&lang=js&"
export * from "./hover-effect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports